<template>
  <div
    id="learning-map"
    class="w-[98%] border-2 h-[1200px] z-10 mt-4 cursor-grab active:cursor-grabbing relative"
    @click="hiddenNodeMenu()"
  >
    <Loader :loader="loader" />
    <div class="absolute right-4 top-4">
      <img src="@/assets/images/learning-map/tutorial.svg" alt="arraste" />
    </div>
    <div class="w-full h-[1200px] relative">
      <div
        ref="titleLabel"
        id="title-label"
        class="z-50 bg-white justify-center hidden items-center flex-col absolute rounded-md shadow-md p-2"
      >
        <p ref="titleP"></p>
      </div>
      <div
        ref="nodeMenu"
        id="node-menu"
        class="z-50 w-fit bg-white hidden justify-center items-center flex-col absolute rounded-md shadow-md"
      >
        <div class="w-full" v-for="item in _menuButtons" :key="item">
          <Button
            class="btn-simple w-full flex justify-center"
            @click="action(item.action)"
            v-if="item.type === choosenNode.type"
          >
            <div class="w-fit">
              <v-icon :name="item.icon" class="text-h-primary-400 mr-3" />
            </div>
            <div class="w-[150%] flex justify-start">
              {{
                $t("labels.generic", {
                  pt: item.title,
                  en: item.titleEN,
                })
              }}
            </div>
          </Button>
        </div>
      </div>
      <v-network-graph
        ref="graph"
        class="graph"
        :configs="configs"
        :nodes="nodes"
        :edges="edges"
        :layouts="layouts"
        :event-handlers="eventHandlers()"
      >
        <defs>
          <clipPath id="faceCircle" clipPathUnits="objectBoundingBox">
            <circle cx="0.5" cy="0.5" r="0.5" />
          </clipPath>
        </defs>

        <template #override-node="{ nodeId, ...slotProps }">
          <circle
            class="face-circle"
            :r="`${nodes[nodeId].width / 2}`"
            fill="#ffffff00"
            v-bind="slotProps"
          />
          <image
            class="face-picture cursor-pointer"
            :x="nodes[nodeId].x"
            :y="nodes[nodeId].y"
            :width="nodes[nodeId].width"
            :height="nodes[nodeId].height"
            :xlink:href="`${nodes[nodeId].face}`"
            clip-path="url(#faceCircle)"
          />
          <circle
            class="face-circle"
            :r="`${nodes[nodeId].width / 2}`"
            fill="none"
            v-bind="slotProps"
          />
        </template>
      </v-network-graph>
    </div>
  </div>
</template>

<script lang="ts">
import { Chapter } from "@/models/chapter.model";
import { getUserFromStorage } from "@/utils/user-store.util";
//@ts-ignore
import * as vNG from "v-network-graph";
import { Edges } from "v-network-graph";
import { defineComponent, reactive } from "vue";
import { LearningMapService } from "./../learning-map.service";
import {
  ActionsButtons,
  menuButtons,
  menuButtonsAdmin,
  nodePositionTeacher,
  svgConfig,
} from "./../learning-map.util";
export default defineComponent({
  name: "learning-map",
  computed: {
    idCourse(): any {
      return this.$route.params.id;
    },
    service(): LearningMapService {
      return new LearningMapService();
    },
  },
  emits: [
    "onAddChapter",
    "onAddObjective",
    "onEditObjective",
    "onShowObjects",
    "onShowBlacklist",
  ],

  data() {
    return {
      nodeSize: 40,
      loader: true,
      edges: {} as Edges,
      nodes: {} as any,
      layouts: reactive({
        nodes: {},
      }) as any,
      nodesAndTrails: [] as any,
      step: { x: 250, y: 150 },
      userId: "",
      _menuButtons: [] as any,
      configs: vNG.defineConfigs({
        view: {
          minZoomLevel: 0,
          maxZoomLevel: 1,
          panEnabled: true,
          autoPanOnResize: true,
        },
        node: {
          draggable: true,
          normal: {
            type: "circle",
            radius: 32,
            width: 32,
            height: 32,
          },
          hover: {
            type: "circle",
            radius: 32,
            width: 32,
            height: 32,
          },
          label: {
            visible: true,
            fontSize: 15,
            lineHeight: 1.1,
            color: "#000000",
            margin: 20,
            direction: "south",
            // directionAutoAdjustment: true,
            background: {
              visible: true,
              color: "#FFF",
              padding: {
                vertical: 0,
                horizontal: 4,
              },
              borderRadius: 2,
            },
          },
        },
        edge: {
          normal: { color: "gray", width: 1 },
          hover: { color: "#000000", width: 2 },
          marker: {
            source: {
              type: "none",
            },
            target: {
              type: "arrow",
            },
          },
        },
      }),
      choosenNode: {} as any,
    };
  },
  props: {
    edge: {
      type: {} as any,
    },
    node: [Object],
    role: [String],
  },
  watch: {
    choosenNode(val) {
      if (
        val.type === "CHAPTER" &&
        val.children?.length !== 0 &&
        this.role === "TEACHER"
      ) {
        const menuButtonsNew = menuButtons.filter(
          (btn) => btn.action !== ActionsButtons.ADD_OBJECTIVE
        );
        this._menuButtons = menuButtonsNew;
      } else this._menuButtons = menuButtons;
    },
  },
  mounted() {
    this.userId = getUserFromStorage()?.id;
    this.nodesAndTrails = this.node?.nodes;
    this.edges = this.node?.edges;
    this.createPoints();
    this._menuButtons =
      this.role === "TEACHER" ? menuButtons : menuButtonsAdmin;
  },
  unmounted() {
    nodePositionTeacher.xCurrent = -800;
  },
  methods: {
    eventHandlers(): vNG.EventHandlers {
      return {
        ...this.clickNode(),
        ...this.pointerOverNode(),
        ...this.pointerOutNode(),
      };
    },
    clickNode(): vNG.EventHandlers {
      return {
        "node:click": ({ node, event }) => {
          const filtered = this.nodesAndTrails?.filter(
            (e: any) => e.id == node
          )[0];
          this.choosenNode = filtered;
          this.showNodeMenu(event.offsetX, event.offsetY);
        },
      };
    },
    pointerOverNode(): vNG.EventHandlers {
      return {
        "node:pointerover": ({ node, event }) => {
          this.nodes[node].face = this.nodes[node].faceHover;
          setTimeout(() => {
            this.showTitleLabel(
              event.offsetX,
              event.offsetY,
              this.nodes[node].nameComplete
            );
          }, 300);
        },
      };
    },
    pointerOutNode(): vNG.EventHandlers {
      return {
        "node:pointerout": ({ node }) => {
          this.nodes[node].face = this.nodes[node].faceOut;
          setTimeout(() => {
            this.hiddenTitleLabel();
          }, 300);
        },
      };
    },
    createPoints(): void {
      const nodeMap = new Map();
      this.nodesAndTrails.forEach((e) => {
        e.children = [];
        nodeMap.set(e.id, e);
        Object.keys(this.edges).forEach((item) => {
          if (this.edges[item].target == e.id) {
            e.father = this.edges[item].source;
          }
        });

        (e.posX = null),
          (e.posY = null),
          (e.config =
            e.type == "CHAPTER" ? svgConfig.chapter : svgConfig.trail),
          (e.isFirst = e.type == "CHAPTER" ? true : false);
        if (e.father !== null) {
          const fatherNode = nodeMap.get(e.father);
          if (fatherNode) {
            fatherNode.children.push(e.id);
          }
        }
        this.createNode(e);
      });

      setTimeout(() => {
        this.createCoordinates();
        this.loader = false;
      }, 100);
    },
    createNode(node) {
      this.nodes[node.id] = {
        name: this.adjustName(node.name),
        nameComplete: node.name,
        type: node.type,
        face: node.config.imgView,
        faceHover: node.config.imgHover,
        faceOut: node.config.imgView,
        x: node.config.x,
        y: node.config.y,
        width: node.config.width,
        height: node.config.height,
        father: node.father,
        children: node.children,
      };
      this.layouts.nodes[node.id] = {
        x: null,
        y: null,
      };
    },
    addNodeChapter(data: Chapter) {
      nodePositionTeacher.xCurrent = -800;
      const node = {
        course: data.course,
        description: data.description,
        id: data.id,
        name: data.name,
        type: "CHAPTER",
        startDate: data.startDate,
      };
      const edge = {
        source: data.id,
        target: data.predecessorId as string,
      };
      this.edges[data.id] = edge;
      this.nodesAndTrails.push(node);
      this.createPoints();
    },
    createCoordinates(): void {
      Object.keys(this.nodes).forEach((node: string) => {
        if (node != "null") {
          if (this.nodes[node]?.type == "CHAPTER") {
            this.layouts.nodes[node] = {
              x: this.checkAndModifyCoordinates(
                nodePositionTeacher.xCurrent,
                nodePositionTeacher.yStart
              ),
              y: nodePositionTeacher.yStart,
            };
          }
          let xFather = this.layouts.nodes[node].x;
          let yFather = this.layouts.nodes[node].y;
          if (this.nodes[node].children.length > 0) {
            for (let child of this.nodes[node].children) {
              this.layouts.nodes[child] = {
                x: this.checkAndModifyCoordinates(xFather, yFather + 150),
                y: yFather + 150,
              };
              xFather = xFather + 200;
            }
          }
          nodePositionTeacher.xCurrent = xFather + 200;
        }
      });
    },
    checkAndModifyCoordinates(x, y): number {
      const coordinates: any = Object.values(this.layouts.nodes);
      for (const coord of coordinates) {
        if (coord.x === x && coord.y === y) {
          x += 200;
          return this.checkAndModifyCoordinates(x, y);
        }
      }
      return x;
    },
    showNodeMenu(posX: number, posY: number): void {
      let menu = this.$refs.nodeMenu as HTMLElement;

      if (menu !== null) {
        menu.style.top = posY + "px";
        menu.style.left = posX + "px";
        menu.style.display = "flex";
      }
    },
    hiddenNodeMenu(): void {
      let menu = this.$refs.nodeMenu as HTMLElement;
      if (menu !== null) {
        menu.style.display = "none";
      }
    },
    action(value: string): void {
      this.hiddenNodeMenu();
      if (value === ActionsButtons.NEXT_CHAPTER) {
        this.$emit("onAddChapter");
      } else if (value === ActionsButtons.EDIT_CHAPTER) {
        this.$emit("onAddChapter", this.choosenNode);
      } else if (value === ActionsButtons.ADD_OBJECTIVE) {
        this.$emit("onAddObjective", this.choosenNode);
      } else if (value === ActionsButtons.EDIT_OBJECTIVE) {
        this.$emit("onEditObjective", this.choosenNode);
      } else if (value === ActionsButtons.VIEW_OBJECTS) {
        this.$emit("onShowObjects", this.choosenNode);
      } else if (value === ActionsButtons.BLACKLIST_OBJECTIVE) {
        this.$emit("onShowBlacklist", this.choosenNode);
      }
    },
    adjustName(name: string): string {
      name = name.toLowerCase();
      if (name.length > 20) {
        name = name.substring(0, 20) + "...";
      }
      let words = name.split(" ");
      let capitalizedWords = words.map(function (word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      });
      return capitalizedWords.join(" ");
    },
    showTitleLabel(posX: number, posY: number, name: string): void {
      let titleLabel = this.$refs.titleLabel as HTMLElement;
      let titleP = this.$refs.titleP as HTMLElement;

      if (titleLabel !== null) {
        titleLabel.style.top = posY + 20 + "px";
        titleLabel.style.left = posX + "px";
        titleP.textContent = name;
        titleLabel.style.display = "flex";
      }
    },
    hiddenTitleLabel(): void {
      let titleLabel = this.$refs.titleLabel as HTMLElement;
      if (titleLabel !== null) {
        titleLabel.style.display = "none";
      }
    },
  },
});
</script>
